<template>
    <div class="page-file">
        <div class="list">
            <template v-for="(item, index) in state.file" :key="item.id">
                <div class="row" @click="handleFile(item)">
                    <div class="left">
                        <div class="name one-line-ellipsis">{{ item.name }}</div>
                    </div>
                    <div class="right">查看 ></div>
                </div>
            </template>
        </div>
    </div>
</template>
<style lang="scss" scoped>
@import "../styles/file.scss";
</style>
<script>
import { ref, reactive, computed, onMounted, nextTick } from 'vue'
import { getFile } from '@/api/service'

export default {
    setup() {
        const state = reactive({
            file: []
        })
        getFile().then(response => {
            let data = response.data
            state.file = data
        }).catch(error => { })
        const handleFile = item => {
            window.location.href = item.fileUrl
        }
        return {
            state,
            handleFile
        }
    }
}
</script>